export default function CardPlanosMensaisResidenciais(props) {
    return (
        <div className="text-black w-full group hover:bg-gray-50 hover:text-azul shadow-lg border h-44 flex-col flex justify-center items-center rounded-[50px] bg-white p-4 px-2 border-blue-300 font-medium">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="size-14 lucide lucide-arrow-up-down-icon lucide-arrow-up-down"><path d="m21 16-4 4-4-4"/><path d="M17 20V4"/><path d="m3 8 4-4 4 4"/><path d="M7 4v16"/></svg>
            <span>{props.descricao}</span>
        </div>
    )
}
